import React, { Component } from "react"
import { connect } from "react-redux"
import * as actions from "../../actions"
import { Menu, MenuItem, MenuMenu, Message } from 'semantic-ui-react'

export class NavBar extends Component {
    state = { logoutError: '' }

    handleLogout = () => {
        this.setState({ logoutError: '' })
        this.props.logout((success, message) => {
            if (success) {
                window.sessionStorage.removeItem('verified2FA')
                return
            }
            this.setState({ logoutError: message })
        })
    }

    renderStaffItem() {
        if (!this.props.isAdmin) return null

        return (
            <MenuItem
                name='users'
                active={this.props.activeItem === 'users'}
                onClick={() => this.props.onChangeItem("users")}
            >
                Staff
            </MenuItem>
        )
    }

    renderRoleItem() {
        if (!this.props.isAdmin) return null

        return (
            <MenuItem
                name='roles'
                active={this.props.activeItem === 'roles'}
                onClick={() => this.props.onChangeItem("roles")}
            >
                Roles
            </MenuItem>
        )
    }

    renderReportsItem() {
        if (!this.props.canViewReports) return null

        return (
            <MenuItem
                name='reports'
                active={this.props.activeItem === 'reports'}
                onClick={() => this.props.onChangeItem("reports")}
            >
                Workflow
            </MenuItem>
        )
    }

    renderQualityReviewItem() {
        if (!this.props.canViewQualityReview) return null

        return (
            <MenuItem
                name='quality-review'
                active={this.props.activeItem === 'quality-review'}
                onClick={() => this.props.onChangeItem("quality-review")}
            >
                Quality Check
            </MenuItem>
        )
    }

    renderRightMenu() {
        const name = this.props.user?.name || ''

        return (
            <MenuMenu position='right'>
                {name && (
                    <MenuItem>
                        Welcome, <strong style={{ marginLeft: 6 }}>{name}</strong>
                    </MenuItem>
                )}
                <MenuItem name='logout' onClick={this.handleLogout}>
                    Logout
                </MenuItem>
            </MenuMenu>
        )
    }

    render() {
        return (
            <>
                {this.state.logoutError && (
                    <Message
                        negative
                        content={this.state.logoutError}
                        onDismiss={() => this.setState({ logoutError: '' })}
                    />
                )}
                <Menu>
                    <MenuItem>
                        <img alt='logo' src='/fmd-logo.png' />
                    </MenuItem>

                <MenuItem
                    name='clients'
                    active={this.props.activeItem === 'clients'}
                    onClick={() => this.props.onChangeItem("clients")}
                >
                    Clients
                </MenuItem>

                <MenuItem
                    name='documents'
                    active={this.props.activeItem === 'documents'}
                    onClick={() => this.props.onChangeItem("documents")}
                >
                    Documents
                </MenuItem>

                    {this.renderReportsItem()}
                    {this.renderQualityReviewItem()}
                    {this.renderStaffItem()}
                    {this.renderRoleItem()}
                    {this.renderRightMenu()}
                </Menu>
            </>
        )
    }
}

export default connect(null, actions)(NavBar)
